module.exports = __webpack_public_path__ + "img/family_bg.8b740869.png";